<template>
	<div class="admin-layout">
		<aside class="admin-sider">
			<div class="admin-logo">
				<div class="admin-logo-name">纷析云</div>
				<div class="admin-logo-sub">管理后台</div>
			</div>
			<ul class="admin-menu">
				<li v-for="menu in menus" :key="menu.path"
					:class="{'admin-menu-active': isActive(menu)}"
					@click="go(menu)">
					<i :class="menu.icon"></i>
					<span>{{ menu.title }}</span>
				</li>
			</ul>
		</aside>
		<div class="admin-main">
			<header class="admin-header">
				<div class="admin-header-title">{{ $route.meta.title || '首页' }}</div>
				<div class="admin-header-right">
					<DropdownMenu trigger="click" offset="0 5" :width="140" placement="bottom-end"
								  :datas="infoMenu" @onclick="trigger">
						<Avatar :src="User.avatarUrl || '/images/yun.png'" :width="28">
							<span>{{ User.realName || User.nickname }}</span>
						</Avatar>
					</DropdownMenu>
				</div>
			</header>
			<main class="admin-content">
				<router-view/>
			</main>
			<footer class="admin-footer">Copyright © 2026 纷析云 All Rights Reserved</footer>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		name: "AdminLayout",
		data() {
			return {
				menus: [
					{path: '/admin/dashboard', title: '首页', icon: 'fa fa-home'},
					{path: '/admin/account-sets', title: '账套管理', icon: 'fa fa-database'},
					{path: '/admin/users', title: '用户管理', icon: 'fa fa-users'},
					{path: '/admin/account-templates', title: '账套模板', icon: 'fa fa-th-large'},
					{path: '/admin/admin-accounts', title: '管理账号', icon: 'fa fa-user-secret'},
					{path: '/admin/site-settings', title: '站点设置', icon: 'fa fa-cog'},
					{path: '/admin/version-management', title: '版本管理', icon: 'fa fa-code-fork'},
					{path: '/admin/renewal-codes', title: '续订代码', icon: 'fa fa-key'},
					{path: '/admin/announcements', title: '系统公告', icon: 'fa fa-bullhorn'},
					{path: '/admin/permission-management', title: '权限管理', icon: 'fa fa-shield'},
					{path: '/admin/payment', title: '收款配置', icon: 'fa fa-credit-card'},
					{path: '/admin/ai-config', title: '智能体配置', icon: 'fa fa-android'},
					{path: '/admin/logs', title: '操作日志', icon: 'fa fa-file-text-o'},
						{path: '/admin/login-logs', title: '登录日志', icon: 'fa fa-sign-in'}
					]
			}
		},
		computed: {
			...mapState(['User']),
			infoMenu() {
				return [
					{key: 'back', title: '返回系统', icon: 'fa fa-reply'},
					{key: 'logout', title: '退出登录', icon: 'h-icon-outbox'}
				];
			}
		},
		methods: {
			isActive(menu) {
				return this.$route.path === menu.path;
			},
			go(menu) {
				if (!this.isActive(menu)) {
					this.$router.push(menu.path);
				}
			},
			trigger(data) {
				if (data === 'logout') {
					this.$api.common.logout().then(() => {
						window.location.replace("/");
					});
				} else if (data === 'back') {
					this.$router.push('/');
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.admin-layout {
		display: flex;
		height: 100vh;
		overflow: hidden;
		background: #f0f2f5;
	}

	.admin-sider {
		width: 220px;
		flex-shrink: 0;
		background: #001529;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
	}

	.admin-logo {
		padding: 20px 16px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);

		&-name {
			color: #fff;
			font-size: 18px;
			font-weight: bold;
			letter-spacing: 2px;
		}

		&-sub {
			color: rgba(255, 255, 255, 0.45);
			font-size: 12px;
			margin-top: 4px;
		}
	}

	.admin-menu {
		list-style: none;
		margin: 0;
		padding: 8px 0;
		flex: 1;

		li {
			display: flex;
			align-items: center;
			padding: 12px 20px;
			color: rgba(255, 255, 255, 0.65);
			cursor: pointer;
			font-size: 14px;
			transition: all 0.2s;

			i {
				width: 20px;
				margin-right: 10px;
				text-align: center;
				font-size: 14px;
			}

			&:hover {
				color: #fff;
				background: rgba(255, 255, 255, 0.06);
			}

			&.admin-menu-active {
				color: #fff;
				background: #1890ff;
			}
		}
	}

	.admin-main {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.admin-header {
		height: 56px;
		flex-shrink: 0;
		background: #fff;
		box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 24px;

		&-title {
			font-size: 16px;
			font-weight: 500;
			color: #333;
		}

		&-right {
			display: flex;
			align-items: center;
		}
	}

	.admin-content {
		flex: 1;
		overflow-y: auto;
		padding: 16px;
	}

	.admin-footer {
		flex-shrink: 0;
		text-align: center;
		color: rgba(0, 0, 0, 0.45);
		font-size: 12px;
		padding: 12px 0;
	}
</style>
